import React from 'react';
import { AppRoute, AppRouter, LoadingPage } from '@launchpad/components';
import SsoVerifyPage from './pages/SsoVerifyPage';

const routes = [<AppRoute path={`/sso/:hash`} component={SsoVerifyPage} />];

export default routes;
